<template>
  <div>
    <TopPreview
      v-if="active === 1 || active === 2"
      :dataList="topPreviewModelList"
      :model="createOrderInfo.model.topPreviewModel"
    />
    <keep-alive>
      <component
        ref="component"
        :leaseInfoParams="leaseInfoParams"
        :maitenaceParams="maitenaceParams"
        :tableDataFrom="tableDataFrom"
        :defaultTable="defaultTable"
        :ladderSchemeConfig="ladderSchemeConfig"
        :createOrderInfo="createOrderInfo"
        :is="stepsList[active].childComponents"
        :leaseOrderDetailData="leaseOrderDetailData"
        @updateCarInfo="updateCarInfo"
        @cancel="cancel"
        @confirm="confirm"
        @previousStep="previousStep"
      />
    </keep-alive>
  </div>
</template>
<script>
import set from 'lodash/set'

// api
import { getCustomerDetail } from '@/api/company'
import { getOrderDetail } from '@/api/domain/carsService'
import { storeList } from '@/api/domain/shop'
import {
  searchByCustomerName,
  searchByCustomerPhone,
} from '@/api/domain/customers'
import TopPreview from '../../components/TopPreview.vue'

// 配置
import createOrderInfoConfig from '../config/createOrderInfo'
// eslint-disable-next-line import/no-cycle
import config from '../../config'
// 其他
import { CATEGORY_FEE_MAP, CATEGORY_CODE_MAP } from '@/store/dict/rentPlanDict.js'
import moment from 'moment'
import { mapState } from 'vuex'
import { addLongTermText } from '@/utils'

export default {
  inject: ['getOrderConfigInfo'],
  components: {
    TopPreview,
  },
  name: 'CreateOrderInfo',
  props: {
    active: {
      type: Number,
      default: -1,
    },
    topPreviewModel: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    const {
      // 进度条
      stepsList,
    } = config.call(this)
    const {
      // 选择客户
      c_baseInfoList,
      c_baseInfoModel,
      c_baseInfoRules,
      // 阶梯配置
      ladderSchemeConfig,
      // 车辆信息
      c_vehicleInfoList,
      c_vehicleInfomodel,
      // 租赁方案选择
      c_leaseSchemeList,
      c_leaseSchemeModel,
      c_leaseSchemeRules,
      // 车型选择
      c_vehicleModelModel,
      // 客户信息
      c_customerInfoList,
      c_customerInfoModel,
      // 车辆选择
      c_vehicleSelectionList,
      c_vehicleSelectionModel,
      c_vehicleSelectionRules,
      // 租赁设置顶部预览
      c_leaseSetupTopPreviewList,
      // 绑定车辆顶部预览
      c_vehicleSelectionTopPreviewList,
    } = createOrderInfoConfig.call(this)
    return {
      // 配置
      stepsList,
      c_baseInfoList,
      c_baseInfoModel,
      c_baseInfoRules,
      ladderSchemeConfig,
      c_leaseSchemeList,
      c_vehicleInfoList,
      c_vehicleInfomodel,
      c_leaseSchemeModel,
      c_leaseSchemeRules,
      c_customerInfoList,
      c_vehicleModelModel,
      c_customerInfoModel,
      c_vehicleSelectionList,
      c_vehicleSelectionModel,
      c_vehicleSelectionRules,
      c_leaseSetupTopPreviewList,
      c_vehicleSelectionTopPreviewList,
      // 租赁信息
      leaseInfoParams: {
        signDate: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'), // 签署日期
        category: 1, // 类别
        startStopDate: [], // 起止日期
        presentDays: '', // 赠送天数
        freedomCycle: '', // 免租周期
      },
      maitenaceParams: {
        // 维保方案
        providerId: '',
        maintenancePlanId: '',
      },
      defaultTable: [],
      tableDataFrom: {
        tableData: [],
      }, // 支付计划
      leaseOrderDetailData: {},
      // 新增车型
      addCarTypeDialog: {
        show: false,
        title: '新增车型',
      },
      oLoading: {
        add: false,
      },
      carInfo: {
        brandId: '',
        seriesId: '',
      },
      rentMallOpenSwitch: false,
    }
  },
  computed: {
    // 创建订单所有的配置和model数据
    createOrderInfo() {
      const {
        // 选择客户
        c_baseInfoList,
        c_baseInfoModel,
        c_baseInfoRules,
        // 顶部预览
        topPreviewModel,
        // 车辆信息
        c_vehicleInfoList,
        c_vehicleInfomodel,
        // 租赁方案选择
        c_leaseSchemeList,
        c_leaseSchemeModel,
        c_leaseSchemeRules,
        // 车型选择
        c_vehicleModelModel,
        // 客户信息
        c_customerInfoList,
        c_customerInfoModel,
        // 车辆选择
        c_vehicleSelectionList,
        c_vehicleSelectionModel,
        c_vehicleSelectionRules,
        // 租赁设置顶部预览
        c_leaseSetupTopPreviewList,
        // 绑定车辆顶部预览
        c_vehicleSelectionTopPreviewList,
      } = this
      const data = {
        list: {
          c_baseInfoList,
          c_vehicleInfoList,
          c_leaseSchemeList,
          c_customerInfoList,
          c_vehicleSelectionList,
          c_leaseSetupTopPreviewList,
          c_vehicleSelectionTopPreviewList,
        },
        model: {
          c_baseInfoModel,
          topPreviewModel,
          c_vehicleInfomodel,
          c_leaseSchemeModel,
          c_vehicleModelModel,
          c_customerInfoModel,
          c_vehicleSelectionModel,
        },
        rules: {
          c_baseInfoRules,
          c_leaseSchemeRules,
          c_vehicleSelectionRules,
        },
      }
      return data
    },
    topPreviewModelList() {
      let previewList = []
      if (this.active === 1) {
        previewList = this.createOrderInfo.list.c_leaseSetupTopPreviewList
      } else if (this.active === 2) {
        previewList = this.createOrderInfo.list.c_vehicleSelectionTopPreviewList
      }
      return previewList
    },
    orderConfigInfo() {
      return this.getOrderConfigInfo()
    },
    ...mapState({
      orderSignRentFee: (state) => state.rentPlan.orderSignRentFee,
      orderSignPurchaseFee: (state) => state.rentPlan.orderSignPurchaseFee, // 已租代购费项
      orderSignCooperateFee: (state) => state.rentPlan.orderSignCooperateFee, // 司机合作模式费项
    }),
  },
  mounted() {
    this.init()
    this.$EventBus.$on('updateTopPreviewModel', (val) => {
      /* eslint-disable vue/no-mutating-props */
      this.topPreviewModel.customerName = val.customerName
      this.topPreviewModel.planName = val.planName
      this.topPreviewModel.modelName = val.modelName
      this.topPreviewModel.categoryName = val.categoryName
      this.topPreviewModel.startStopDate = val.startStopDate
      /* eslint-enable vue/no-mutating-props */
    })
  },
  activated() {
    // 缓存页面切换回来时重新请求门店列表接口
    this.handleGetStore()
  },
  methods: {
    // 是否备车切换
    // eslint-disable-next-line vue/no-unused-properties
    readyLeaseStateChange() {
      this.$refs.component.plateNoRemoteMethod()
    },
    // 车辆选择
    // eslint-disable-next-line vue/no-unused-properties
    plateNoChange(id) {
      this.$refs.component.plateNoChange(id)
    },
    // 请求门店列表
    handleGetStore() {
      this.$refs.component.$refs.baseInfoInfo &&
        this.$refs.component.$refs.baseInfoInfo.setItemData({
          elConfigKey: 'loading',
          key: 'storeId',
          data: true,
        })
      return new Promise((resolve, reject) => {
        storeList({ pageSize: 999, name: this.c_baseInfoModel.storeName })
          .then((res) => {
            if (res.code === 1 && res.data) {
              this.$refs.component.$refs.baseInfoInfo &&
                this.$refs.component.$refs.baseInfoInfo.setItemData({
                  elConfigKey: 'list',
                  key: 'storeId',
                  data: res?.data?.items || [],
                })
              this.$refs.component.$refs.baseInfoInfo &&
                this.$refs.component.$refs.baseInfoInfo.setItemData({
                  elConfigKey: 'loading',
                  key: 'storeId',
                  data: false,
                })
              resolve({ status: 1, message: '门店列表请求成功' })
            } else {
              reject({
                status: 0,
                message: `门店列表接口请求成功，返回值中没有data，为${res}`,
              })
            }
          })
          .catch((err) => {
            reject({ status: 0, message: `门店列表接口请求失败，${err}` })
          })
      })
    },
    // 租赁方案选择
    // eslint-disable-next-line vue/no-unused-properties
    planChange(id) {
      this.$refs.component.planChange(id)
    },
    // 清空租赁数据
    clearLeaseSetupModel() {
      this.c_leaseSchemeModel.planId = 0
      this.c_vehicleModelModel.modelId = ''
      this.c_vehicleSelectionModel.readyLeaseState = ''
      this.c_vehicleSelectionModel.plateNo = ''
      this.leaseInfoParams = {
        signDate: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'), // 签署日期
        rentCategory: 1, // 类别
        startStopDate: [], // 起止日期
        presentDays: '', // 赠送天数
        freedomCycle: '', // 免租周期
        modelId: '',
        plateNo: '',
      }

      this.ladderSchemeConfig = {
        isOpen: 0,
        unit: 1,
        clickNumber: 0, // 点击匹配租金次数
        ladderSchemeConfig: false, // 置灰
        ladderSchemeList: [
          {
            startMonth: 1, // 开始时间为1
            endMonth: '',
            amount: '',
          },
          {
            startMonth: '',
            endMonth: '',
            amount: '',
          },
        ],
      }
      this.tableDataFrom.tableData = [...this.defaultTable]
    },
    // 清空客户信息
    clearCustomerInfoModel() {
      this.c_customerInfoModel.customerId = ''
      this.c_customerInfoModel.idCardNo = ''
      this.c_customerInfoModel.customerTel = ''
      this.c_customerInfoModel.customerName = ''
      this.c_customerInfoModel.idCardValidDate = ''
      this.c_customerInfoModel.driverLicenceValidDate = ''
      this.c_customerInfoModel.hailingLicenceValidDate = ''
    },
    // 客户选择
    customerNameChange(id) {
      if (!id) {
        // 清空客户信息
        this.clearCustomerInfoModel()
        return
      }
      getCustomerDetail({
        id,
      }).then((res) => {
        const {
          data: {
            // eslint-disable-next-line no-shadow
            id,
            customerName,
            customerTel,
            individualCustomerVo: {
              idCardNo,
              idCardValidDate,
              driverLicenceValidDate,
              driverLicenceValidDays,
              hailingLicenceValidDate,
              hailingLicenceValidDays,
            },
          },
        } = res
        this.c_customerInfoModel.customerId = id
        this.c_customerInfoModel.idCardNo = idCardNo
        this.c_customerInfoModel.customerTel = customerTel
        this.c_customerInfoModel.customerName = customerName
        this.c_customerInfoModel.idCardValidDate =
          (idCardValidDate && addLongTermText(idCardValidDate)) || ''
        this.c_customerInfoModel.driverLicenceValidDate = this.longTermWithDays(
          driverLicenceValidDate,
          driverLicenceValidDays,
        )
        this.c_customerInfoModel.hailingLicenceValidDate =
          this.longTermWithDays(
            hailingLicenceValidDate,
            hailingLicenceValidDays,
          )
        /* eslint-disable vue/no-mutating-props */
        this.topPreviewModel.customerName = customerName
        this.topPreviewModel.idCardNo = idCardNo
        this.topPreviewModel.customerTel = customerTel
      })
    },
    // 带剩余天数的回显
    longTermWithDays(dateStr, days) {
      if (dateStr) {
        const formatDate = addLongTermText(dateStr)
        return formatDate === '长期有效' ? '长期有效' : `${formatDate}(${days})`
      }
      return ''
    },
    // 客户模糊查询
    // eslint-disable-next-line vue/no-unused-properties
    customerNameRemoteMethod(val) {
      if (val.length < 1) return
      searchByCustomerName({
        customerName: val,
        customerType: 1,
        customerState: 1, // 客户状态 0禁用 1启用
      }).then((res) => {
        const { data = [] } = res
        this.$refs.component.$refs.baseInfoInfo.setItemData({
          elConfigKey: 'list',
          key: 'customerName',
          data,
        })
      })
    },
    // 新增客户抽屉弹出事件
    // eslint-disable-next-line vue/no-unused-properties
    tipsClick() {
      // 个人租赁订单的逻辑走这里
      window.open('/driver/customerManage/add/person', '_blank')
    },
    // 取消
    cancel() {
      this.$confirm(
        '是否确认退出创建个人签约提车流程?退出后已编辑的信息将不再保存',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        },
      )
        .then(() => {
          this.$emit('cancel')
          // eslint-disable-next-line @typescript-eslint/no-empty-function
        })
        .catch(() => null)
    },
    // 上一步
    previousStep() {
      this.$emit('previousStep')
    },
    // 确认
    confirm() {
      this.$emit('confirm', this.active + 1)
    },
    searchCustomerByPhone(customerTel) {
      // 个人签约提车
      searchByCustomerPhone({ customerTel, customerType: 1 })
        .then((res) => {
          if (res.code === 1) {
            const { data } = res
            const hasCustomer = Array.isArray(data) && data.length > 0
            if (hasCustomer) {
              // 通过手机号查询到了客户
              const customerItem = data[0]
              // 展示客户详情
              customerItem.id && this.customerNameChange(customerItem.id)
              // 客户姓名
              set(
                this.c_baseInfoModel,
                'customerName',
                customerItem.customerName,
              )
            }
          } else {
            throw new Error(`查询客户异常code:${res.code}`)
          }
        })
    },
    async init() {
      // 获取租赁类别枚举
      await this.$store.dispatch('getPaymentMethods', { type: 'rentCategory' })
      if (this.topPreviewModel.leadPhone) {
        this.searchCustomerByPhone(this.topPreviewModel.leadPhone)
      }
      const { orderId } = this.$route.query
      const res = await this.$store.dispatch('getRentMallOpenSwitchFn')
      if (res.code === 1) {
        this.rentMallOpenSwitch = res.data
      }

      orderId && this.queryLeaseOrderDetail(orderId)

      // 获取门店列表
      this.handleGetStore()
    },
    // 请求租赁订单详情
    async queryLeaseOrderDetail(orderId) {
      const { code, data } = await getOrderDetail({ orderId })
      if (code === 1) {
        this.leaseOrderDetailData = data || {}
        const { storeName, storeId, customerId, customerName, planId } = data
        this.c_baseInfoModel.storeName = storeName
        const res = await this.handleGetStore()
        if (res.status === 1) {
          this.$nextTick(() => {
            this.c_baseInfoModel.storeId = storeId
            this.c_baseInfoList.find(
              (item) => item.itemConfig.prop === 'storeId',
            ).elConfig.disabled = true
          })
          // 每个步骤上的顶部信息
          this.handleTopPreview()
          // eslint-disable-next-line vue/no-mutating-props
          this.topPreviewModel.storeName = storeName
        }
        /** 客户反显 */
        this.c_baseInfoModel.customerName = customerId
        this.$refs.component.$refs.baseInfoInfo &&
          this.$refs.component.$refs.baseInfoInfo.setItemData({
            elConfigKey: 'list',
            key: 'customerName',
            data: [{ id: customerId, customerName }],
          })
        this.c_baseInfoList.find(
          (item) => item.itemConfig.prop === 'customerName',
        ).elConfig.disabled = true
        this.customerNameChange(customerId)

        /** 租赁方案反显 */
        this.c_leaseSchemeModel.planId = planId
      }
    },
    handleTopPreview() {
      const elFormItem = this.createOrderInfo.list.c_baseInfoList?.find(
        (item) => item.itemConfig.prop === 'storeId',
      )
      const someStore = elFormItem.elConfig?.options?.list?.find(
        (item) =>
          Number(item.id) ===
          Number(this.createOrderInfo.model.c_baseInfoModel.storeId),
      )
      if (!this.createOrderInfo.model.topPreviewModel.storeName) {
        this.createOrderInfo.model.topPreviewModel.storeName =
          someStore?.name || ''
      }
      if (!this.createOrderInfo.model.topPreviewModel.customerName) {
        this.createOrderInfo.model.topPreviewModel.customerName =
          this.createOrderInfo.model.c_customerInfoModel.customerName
      }
      if (!this.createOrderInfo.model.topPreviewModel.rentCalculationRules) {
        this.createOrderInfo.model.topPreviewModel.rentCalculationRules =
          this.createOrderInfo.model.c_baseInfoModel.rentCalculationRules
      }
    },
    // 商城下的单，进行绑车，会发生没有车型的情况，需要手动添加
    updateCarInfo(val) {
      this.carInfo = val
    },
  },
  watch: {
    orderConfigInfo: {
      async handler(info) {
        this.c_leaseSchemeModel.planId = info.planId
        this.c_vehicleModelModel.modelId = info.modelId

        this.leaseInfoParams = {
          signDate: `${info.signDate} 00:00:00`, // 签署日期
          rentCategory: info.rentCategory, // 类别
          startStopDate: [
            `${info.startDate} 00:00:00`,
            `${info.endDate} 00:00:00`,
          ], // 起止日期
          presentDays: info.presentDays, // 赠送天数
          preFreeRentDays: info.preFreeRentDays, // 前置免租天数
          payPlanFee: info.payPlanFee,
          modelId: info.modelId,
          carId: info.carId,
          plateNo: info.plateNo,
        }

        if (this.orderConfigInfo.rentCategory !== CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
          // 根据store保存的配置设置required值
          await this.$store.dispatch('getFeeList', {
            type: CATEGORY_FEE_MAP[this.orderConfigInfo.rentCategory],
          })
          const orderAccruedPlans = info.orderAccruedPlans?.map((item) => {
            const feeCategories = this[CATEGORY_FEE_MAP[info.rentCategory]]
            const fee = feeCategories.find((i) => i.code === item.fundType)
            return {
              ...item,
              name: item.fundTypeName,
              required: fee.required, // 是否必填 boolean
              isConfirm: true,
              toast: fee.toast,
              isSelectScheme: info.planId !== 0,
            }
          })

          this.defaultTable = [...orderAccruedPlans]
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.qs-scrollerBox {
  margin-right: 0;
}

::v-deep .bottom-action-inner{
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  bottom: 10px;
}
</style>
